<!--
  *************************************************************************************************
-->
<waitLoading *ngIf="!isLoaded()"></waitLoading>
<!--
  *************************************************************************************************
-->
<div class="wrapper wrapper-content ng-scope animated fadeInRight" *ngIf="isLoaded()">
    <div class="row ">
        <div class="col-lg-6">
            <h3>{{ 'UserPrefs.user.pref.header' | translate }}</h3>
        </div>
        <!--
      div class="ui-menubar ui-widget ui-widget-content ui-corner-all col-lg-6 float-right">
          <button class="btn btn-success" (click)="validate()">
            <i class="fa fa-check-square-o" aria-hidden="true"></i>{{'GenericDossier.validate' | translate}}</button>
          <button class="btn btn-primary" (click)="save()">
            <i class="fa fa-save" aria-hidden="true"></i>{{'GenericDossier.save' | translate}}</button>

        </div
    -->
    </div>
    <div class="row">
        <!-- Seleccion de idioma -->
        <div class="col-12 m-t-sm" *ngIf="languajeService.getAvaliableLanguages().length > 1">
            <p-panel>
                <p-header>
                    <span>
                        <i class="fas fa-flag" aria-hidden="true"></i> {{ 'Languages.Sel_lang' | translate }}</span>
                </p-header>
                <lang-selection></lang-selection>
            </p-panel>
        </div>
        <!--  configurar si el usuario desea recibir notificaciones de tareas por mail  -->
        <div class="col-12 col-md-6 m-t-sm">
            <p-panel>
                <p-header>
                    <span>
                        <i class="fa fa-bell" aria-hidden="true"></i> {{ 'UserPrefs.notif.title' | translate }}</span>
                </p-header>
                <div class="ui-widget-content p-h-m"> {{ 'UserPrefs.receiveNotifMessage.p1' | translate }} <br />{{
                    'UserPrefs.receiveNotifMessage.p2' | translate }} </div>
                <div class="p-h-m"> {{ 'UserPrefs.receiveNotifMessage.label' | translate }} <p-inputSwitch
                        onLabel="Activado" offLabel="Desactivado" (onChange)="updateRecibirNotif($event)"
                        [(ngModel)]="recibirNotif" class="btn">
                    </p-inputSwitch>
                </div>
            </p-panel>
        </div>
        <!-- Preferencias de Visualización -->
        <div class="col-12 col-md-6 m-t-sm">
            <p-panel>
                <p-header>
                    <span>
                        <i class="fa fa-television" aria-hidden="true"></i> {{ 'UserPrefs.visualization.title' |
                        translate }}</span>
                </p-header>
                <div class="ui-widget-content p-h-m"> {{ 'UserPrefs.visualization.p1' | translate }} </div>
                <div class="pb-3"> {{ 'UserPrefs.visualization.showProfiles' | translate }} <p-inputSwitch
                        onLabel="Activado" offLabel="Desactivado" [(ngModel)]="userPrefs.tasksViewPrefs.showProfile"
                        class="btn" (onChange)="save($event)">
                    </p-inputSwitch>
                </div>
                <div *ngIf="userService.hasRoles('0,50')" class="pb-3"> {{ 'UserPrefs.visualization.viewHelpTags' |
                    translate }} <p-inputSwitch onLabel="Activado" offLabel="Desactivado"
                        [(ngModel)]="userPrefs.mainViewPrefs.showHelpTags" class="btn" (onChange)="save($event)">
                    </p-inputSwitch>
                </div>
            </p-panel>
        </div>
    </div>
    <div class="row " *ngIf="modifyPassAvailable||is2FAAvailable">
        <div class="col-lg-6">
            <h3>{{ 'UserPrefs.security.title' | translate }}</h3>
        </div>
        <!--
      div class="ui-menubar ui-widget ui-widget-content ui-corner-all col-lg-6 float-right">
          <button class="btn btn-success" (click)="validate()">
            <i class="fa fa-check-square-o" aria-hidden="true"></i>{{'GenericDossier.validate' | translate}}</button>
          <button class="btn btn-primary" (click)="save()">
            <i class="fa fa-save" aria-hidden="true"></i>{{'GenericDossier.save' | translate}}</button>

        </div
    -->
    </div>
    <div class="row">
        <!-- Modificar el password -->
        <!-- Disponible si no SSO ni LDAP -->
        <div class="col-12 col-md-6 m-t-sm" *ngIf="modifyPassAvailable">
            <user-password></user-password>
        </div>
        <!-- 2FA -->
        <div class="col-12 col-md-6 m-t-sm" *ngIf="is2FAAvailable">
            <user-2fa></user-2fa>
        </div>
    </div>
    <div class="row ">
        <div class="col-lg-6">
            <h3>{{ 'General.utilities' | translate }}</h3>
        </div>
        <!--
      div class="ui-menubar ui-widget ui-widget-content ui-corner-all col-lg-6 float-right">
          <button class="btn btn-success" (click)="validate()">
            <i class="fa fa-check-square-o" aria-hidden="true"></i>{{'GenericDossier.validate' | translate}}</button>
          <button class="btn btn-primary" (click)="save()">
            <i class="fa fa-save" aria-hidden="true"></i>{{'GenericDossier.save' | translate}}</button>

        </div
    -->
    </div>
    <div class="row">
        <div class="col-12 col-md-6 m-t-sm">
            <!-- limpiar configuración local del usuario -->
            <!--
        Eliminar configuración local del usuario. Se perderán filtros, ordenaciones y preferencias.
      -->
            <p-panel>
                <p-header>
                    <span>
                        <i class="fas fa-redo-alt" aria-hidden="true"></i> {{ 'UserPrefs.reset.title' | translate
                        }}</span>
                </p-header>
                <div class="ui-widget-content p-h-m"> {{ 'UserPrefs.clearLocalConfig.p1' | translate }} <br />{{
                    'UserPrefs.clearLocalConfig.p2' | translate }} </div>
                <div class="ui-menubar ui-widget ui-widget-content ui-corner-all p-h-m">
                    <button class="btn btn-primary" style="width: 100%" (click)="clearPrefs()">
                        <i class="fas fa-times" aria-hidden="true"></i> {{ 'UserPrefs.reset.title' | translate }}
                    </button>
                </div>
            </p-panel>
        </div>
        <div class="col-12 col-md-6 m-t-sm">
            <p-panel>
                <p-header>
                    <span>
                        <i class="fas fa-file-signature" aria-hidden="true"></i> {{ 'UserPrefs.checkAutoFirma.title' |
                        translate }}</span>
                </p-header>
                <div class="ui-widget-content p-h-m"> {{ 'UserPrefs.checkAutoFirma.message' | translate }} </div>
                <div class="ui-menubar ui-widget ui-widget-content ui-corner-all p-h-m">
                    <button class="btn btn-default" style="width: 100%" (click)="checkAutoFirma()">
                        <i class="fas fa-pen-square" aria-hidden="true"></i> {{ 'UserPrefs.checkAutoFirma.action' |
                        translate }} </button>
                    <label class="control-label">{{ estadoAutoFirma }}</label>
                </div>
                <div class="ui-widget-content p-h-m">
                    <label class="control-label m-r-sm">{{ 'UserPrefs.keystoreSelect' | translate }}</label>
                    <p-dropdown [options]="aFirmaService.getKeystores()"
                        [(ngModel)]="userPrefs.signaturePrefs.keystore"></p-dropdown>
                </div>
            </p-panel>
        </div>
    </div>
    <div class="row ">
        <div class="col-lg-12">
            <h3>{{ 'UserPrefs.documents.group' | translate }}</h3>
        </div>
        <div class="col-12 col-md-6 m-t-sm">
            <p-panel>
                <p-header>
                    <span>
                        <i class="fas fa-book" aria-hidden="true"></i> {{ 'UserPrefs.documents.title' | translate
                        }}</span>
                </p-header>
                <ng-template [ngIf]="welcomeNotes && welcomeNotes.length > 0">
                    <div *ngFor="let note of welcomeNotes" class="m-b-md m-t-sm">
                        <span>
                            <i class="fa fa-desktop" aria-hidden="true"></i> {{note.description}}</span>
                        <button class="btn btn-outline-primary btn-sm m-l-md"
                            (click)="welcomeNotesService.viewNote(note.id)" role="link">
                            <i class="far fa-eye"></i> {{'DocumentsAction.view'|translate}}</button>
                    </div>
                </ng-template>
            </p-panel>
        </div>
    </div>
</div>